export const INITIAL_SELECTED_STORE = {
  storeId: 0,
  orders: 0,
  sales: 0,
  campaignId: 0,
  status: false,
  domain: "",
  activityType: "",
  primaryColor: "",
  secondaryColor: "",
  managerId: "",
  groupLeaderEmail: "",
  accountManagerId: "",
  entityId: 0,
  name: "",
  code: "",
  email: "",
  teamName: "",
  digitalLogo: "",
  enabled: false,
  totalPoints: 0,
  totalSales: 0,
  totalOrders: 0,
  totalDiscountAmount: 0,
  pointsPercentage: 0,
  headerLogo: "",
  embroideryLogo: "",
  hatLogo: "",
  brands: [],
  productColors: [],
  expiringPoints: 0,
  earnedPointsBalance: 0,
  earnedPoints: 0,
};

export const INITIAL_STORE_PROFIT_PERCENTAGE = {
  productPricePercentage: null,
  defaultProductPricePercentage: null,
  lastUpdated: null,
  loader: false,
};
